$(document).ready(function(){
  
    function ArandomIntFromInterval(min, max) { // min and max included 
    //return Math.floor(Math.random() * (max - min + 1) + min)
    min = Math.ceil(min);
    max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function SrandomIntFromInterval(min, max) { // min and max included 
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }$('#Adv_InventoryQuantity').show();
  
    var Amin = '7';
    var Amax = '10';
    var Arandom_number =  ArandomIntFromInterval(Amin, Amax)
    if(Arandom_number == 0){
      var Arandom_number = 7; 
    }
  	$('.adv_quantity-item-temp-pre').text(Arandom_number);
  
    var Smin = '11';
    var Smax = '14';
    var Srandom_number =  SrandomIntFromInterval(Smin, Smax)
    if(Srandom_number == 0){
      var Srandom_number = 11; 
    }
    $('.adv_quantity-item-temp').text(Srandom_number);});